import { SystemService } from "./SystemService";
import AuthService from "./AuthService";

class SchedulesService {
    systemService = null;
    api = null;
    authService = null;

    constructor() {
        this.systemService = new SystemService();
        this.authService = new AuthService();
        this.api = this.systemService.getApiAccess();
    }

    getSchedule(machineId, date) {
        let sessionId = this.authService.getSessionId();
        return this.api.get('schedules', { 
            params: { machineId, date },
            headers: { authorization: sessionId } 
        });
    }

    getAllSchedules(startDate, endDate) {
        let sessionId = this.authService.getSessionId();
        return this.api.get('schedules', { 
            params: { startDate, endDate },
            headers: { authorization: sessionId } 
        });
    }

    createOrUpdateSchedule(machineId, date, shelfNames, dateTo = null) {
        let sessionId = this.authService.getSessionId();
        return this.api.post('schedules', { machineId, date, shelfNames, dateTo }, { 
            headers: { authorization: sessionId } 
        });
    }

    deleteSchedule(id) {
        let sessionId = this.authService.getSessionId();
        return this.api.delete(`schedules/${id}`, { 
            headers: { authorization: sessionId } 
        });
    }
}

export default SchedulesService;
